import { html, LitElement, } from 'lit-element';

export class IconLocation extends LitElement {  
  static get properties() {
    return {
      width: { type: Number, },
      height: { type: Number, },
    };
  }

  constructor() {
    super();
    this.width = 20;
    this.height = 20;
  }

  render() {
    return html`
    <svg width="${this.width}" height="${this.height}" fill="currentColor" version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132.02 132.02" style="enable-background:new 0 0 132.02 132.02;" xml:space="preserve"><style type="text/css">.st0{fill:#E9E6E4;}.st1{fill:#797979;}</style><g id="Group_766" transform="translate(1.195 38.288)"><g id="Ellipse_489"><ellipse class="st0" cx="67.26" cy="18.52" rx="10.39" ry="10.39"/></g><g id="Ellipse_490"><path class="st1" d="M64.81,31.6c-8.56,0-15.53-6.96-15.53-15.53S56.24,0.55,64.81,0.55s15.53,6.96,15.53,15.53S73.37,31.6,64.81,31.6z M64.81,5.96c-5.58,0-10.12,4.54-10.12,10.12s4.54,10.12,10.12,10.12s10.12-4.54,10.12-10.12S70.39,5.96,64.81,5.96z"/></g><g id="Path_665"><path class="st1" d="M64.83,78.3c-0.88,0-1.7-0.42-2.2-1.14L32.62,35.04c-0.07-0.11-0.36-0.65-0.43-0.77c-7.05-11.81-7.05-26.68,0.08-38.66c10.7-17.95,34.02-23.83,51.95-13.14c17.95,10.7,23.85,34.01,13.15,51.95c-0.06,0.11-0.14,0.21-0.21,0.31c-0.55,0.91-1.15,1.81-1.77,2.66L94,39.28c-0.8,1.08-1.6,2.16-2.37,3.25l-24.6,34.63C66.53,77.88,65.71,78.3,64.83,78.3L64.83,78.3z M64.88-17.46c-11.07,0-21.88,5.65-27.95,15.84c-6.12,10.27-6.12,23.01,0,33.27c0.03,0.05,0.28,0.53,0.31,0.59l27.59,38.69l22.4-31.52c0.79-1.12,1.62-2.23,2.44-3.34l1.37-1.86c0.58-0.79,1.13-1.63,1.64-2.49c0.06-0.11,0.13-0.21,0.21-0.3c8.98-15.35,3.89-35.17-11.41-44.3C76.26-15.98,70.54-17.46,64.88-17.46z M95.05,33.04h0.05H95.05z"/></g></g></svg>
    `;
  }
}

customElements.define('icon-location', IconLocation);